import {
  BLACK_LISTED_END_PATHS,
  HEADER_BLACK_LISTED_START_PATHS
} from '~/config/constants';
import { pathnameStartsOrEndsWithRoute } from './router';
import { TranslateFunction } from '~/Locale';

export const showHeader = (t: TranslateFunction, pathname: string) =>
  !pathnameStartsOrEndsWithRoute({
    t,
    pathname,
    startPaths: HEADER_BLACK_LISTED_START_PATHS,
    endPaths: BLACK_LISTED_END_PATHS
  });
